import { render, staticRenderFns } from "./PlayerMultiHeader.vue?vue&type=template&id=132b324e&"
import script from "./PlayerMultiHeader.vue?vue&type=script&lang=js&"
export * from "./PlayerMultiHeader.vue?vue&type=script&lang=js&"
import style0 from "./PlayerMultiHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports